// 货品列表
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { Form, Table, Button, Row, Col, Input, Select, Divider, Modal, Alert, message } from 'antd';
import { TreeSelect } from 'antd-v5';
import { productList, categoryList } from '../../../../state/action/batch';
import { Table as AntTable } from 'antd';
import {
  SALE_TYPE,
  PACK_KIND_NAME,
  getDefaultGoodsSaleTypeByStall,
} from '../../../../utils/deviceType';

import './device.less';
import {
  addSpuRelationRequest,
  deleteSpuRelationRequest,
  getSpuCategoryTreeListRequest,
  pageSpuRequest,
} from '../../../../state/request/cxmProductSpuCategory';

const FormItem = Form.Item;
const pageSize = 10;

const testcolumns = [
  {
    title: '基库货品ID',
    dataIndex: 'id',
    key: 'id',
    width: 120,
  },
  {
    title: '基库货品',
    dataIndex: 'name',
    key: 'name',
    width: 180,
  },
  {
    title: '货品分类',
    dataIndex: 'categoryName',
    key: 'categoryName',
    width: 200,
  },
];

@connect(
  (state) => {
    return { batch: state.batch };
  },
  {
    productList: productList,
    categoryList: categoryList,
  },
)
@Form.create()
class StallProductList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      pageNo: 1, // 请求页码
      visible: false,
      mergeRecord: {},
      searchValues: {},
      defaultCurrent: 1,
      dataSource: {},
      treeData: [],
    };
    this.formRef = React.createRef();
  }

  componentDidMount() {
    this.loadAllData();
  }

  //加载全部数据
  loadAllData() {
    this.getProductList({ pageNo: this.state.pageNo, pageSize });
    this.getCategoryList();
  }

  async getCategoryList() {
    await this.props.categoryList({ stallId: this.props.stallId });
  }

  async getProductList(params) {
    this.setState({ loading: true });
    params.stallId = this.props.stallId;
    if (!params.saleType) {
      params.saleType = getDefaultGoodsSaleTypeByStall(this.props.saleType);
    }
    await this.props.productList(params);
    this.setState({ loading: false, pageNo: params.pageNo });
  }

  // 重置按钮
  handleReset = () => {
    this.props.form.resetFields();
    this.props.form.setFieldsValue({
      categoryId: undefined,
      saleType: getDefaultGoodsSaleTypeByStall(this.props.saleType),
    });
    this.loadAllData();
  };

  // 查询
  handleSearch = (e) => {
    e.preventDefault();
    this.props.form.validateFields((errors, fieldsValue) => {
      if (!!errors) {
        return;
      }
      // 查询
      this.getProductList({ ...fieldsValue, pageNo: 1, pageSize });
    });
  };

  /**
   * 切换页面
   * @param {*} obj
   */
  pageSwitch = (obj) => {
    this.setState({ pageNo: obj.current }, () => {
      this.props.form.validateFields((errors, fieldsValue) => {
        if (!!errors) {
          return;
        }
        // 查询
        this.getProductList({ ...fieldsValue, pageNo: obj.current, pageSize });
      });
    });
  };

  handleMerge = (record) => {
    this.setState({ visible: true, mergeRecord: record }, () => {
      this.getSupPage();
      this.getSpuCategoryList();
    });
  };

  handleUnmerge = (record) => {
    Modal.confirm({
      title: '提示',
      content: '确定解除关联吗？',
      okText: '确认',
      cancelText: '取消',
      onOk: async () => {
        const res = await deleteSpuRelationRequest({
          stallId: this.props.stallId,
          productId: record.productId,
        });
        if (res.code === 200) {
          message.success('解除关联成功');
          this.props.form.validateFields((errors, fieldsValue) => {
            if (!!errors) {
              return;
            }
            // 查询
            this.getProductList({ ...fieldsValue, pageNo: this.state.pageNo, pageSize });
          });
        }
      },
      onCancel() {},
    });
  };

  onSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };

  handleOk = async () => {
    const { selectedRowKeys, mergeRecord, pageNo } = this.state;
    const res = await addSpuRelationRequest({
      stallId: this.props.stallId,
      productId: mergeRecord.productId,
      spuId: selectedRowKeys[0],
    });
    if (res.code === 200) {
      this.setState({ visible: false });
      this.props.form.validateFields((errors, fieldsValue) => {
        if (!!errors) {
          return;
        }
        // 查询
        this.getProductList({ ...fieldsValue, pageNo, pageSize });
      });
    }
  };

  handleCancel = () => {
    this.setState({ visible: false });
  };

  async getSupPage() {
    this.setState({ loading: true });
    const { defaultCurrent, searchValues } = this.state;
    const params = {
      ...searchValues,
      pageNo: defaultCurrent,
      pageSize,
    };
    const res = await pageSpuRequest(params);
    this.setState({ loading: false });
    if (res.code === 200) {
      this.setState({
        dataSource: res.data,
      });
    }
  }
  // 查询
  handleSpuSearch = () => {
    this.setState(
      {
        defaultCurrent: 1,
      },
      () => {
        this.getSupPage();
      },
    );
  };
  // 重置
  handleSpuReset = () => {
    this.setState(
      {
        defaultCurrent: 1,
        searchValues: {},
      },
      () => {
        this.getSupPage();
      },
    );
  };

  supPageSwitch = (obj) => {
    this.setState(
      {
        defaultCurrent: obj.current,
      },
      () => {
        this.getSupPage();
      },
    );
  };

  getSpuCategoryList = async () => {
    const res = await getSpuCategoryTreeListRequest();
    if (res?.code === 200) {
      this.setState({ treeData: res.data });
    }
  };
  convertToTreeData = (data, disabled = false) => {
    if (!Array.isArray(data)) return [];
    return data.map((item) => ({
      title: item.name,
      value: item.id,
      level: item.level,
      disabled: disabled ? item.level === 1 || item.level === 2 : false,
      children: this.convertToTreeData(item.childNodeList, disabled),
    }));
  };

  render() {
    const {
      loading,
      pageNo,
      visible,
      selectedRowKeys,
      dataSource,
      searchValues,
      treeData,
      defaultCurrent,
    } = this.state;
    const {
      batch: { productList = {}, categoryList = [] },
    } = this.props;

    const { getFieldDecorator } = this.props.form;
    const { pageList = [], totalSize = 1 } = productList;
    const pagination = {
      current: pageNo,
      pageSize,
      total: totalSize,
    };
    const layout = { xs: 24, sm: 12, md: 6, lg: 6, xl: 6 };

    const columns = [
      {
        title: '货品',
        dataIndex: 'productName',
      },
      {
        title: '近七天价格区间',
        dataIndex: 'priceRange',
        render: (text) => {
          return text ? text : '';
        },
      },
      {
        title: '包装类型',
        dataIndex: 'goodsKindType',
        render: (text) => {
          return PACK_KIND_NAME.get(text) || '';
        },
      },
      {
        title: '售卖方式',
        dataIndex: 'saleType',
        render: (text) => {
          return SALE_TYPE.get(text) || '';
        },
      },
      {
        title: '分类名称',
        dataIndex: 'categoryName',
        render: (text, record) => {
          if (record.saleType === 2) {
            return text ? text : '未分类';
          }
          return text ? text : '';
        },
      },
      {
        title: 'SPU',
        dataIndex: 'spuId',
      },
      {
        title: '基库货品',
        dataIndex: 'spuName',
      },
      {
        title: '操作',
        dataIndex: 'operation',
        render: (text, record) => {
          return (
            <div>
              <a
                href='/'
                onClick={(e) => {
                  e.preventDefault();
                  this.handleMerge(record);
                }}
              >
                关联SPU
              </a>
              {record.spuId && (
                <>
                  <Divider type='vertical' />
                  <a
                    href='/'
                    onClick={(e) => {
                      e.preventDefault();
                      this.handleUnmerge(record);
                    }}
                  >
                    解除关联
                  </a>
                </>
              )}
            </div>
          );
        },
      },
    ];

    return (
      <div className='basketSettings'>
        <div>
          <Form layout='inline' onSubmit={this.handleSearch}>
            <Row gutter={24}>
              <Col {...layout}>
                <FormItem label='货品'>
                  {getFieldDecorator('productName', {
                    rules: [{ required: false, message: '请输入货品!' }],
                  })(<Input placeholder='请输入货品' allowClear />)}
                </FormItem>
              </Col>
              <Col {...layout}>
                <FormItem label='售卖方式'>
                  {getFieldDecorator('saleType', {
                    initialValue: getDefaultGoodsSaleTypeByStall(this.props.saleType),
                    rules: [{ required: false, message: '请选择售卖方式' }],
                  })(
                    <Select
                      placeholder='请选择售卖方式'
                      showSearch
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {[...SALE_TYPE].map(([key, value]) =>
                        key !== 3 ? (
                          <Select.Option key={key} value={key}>
                            {value}
                          </Select.Option>
                        ) : null,
                      )}
                    </Select>,
                  )}
                </FormItem>
              </Col>
              <Col {...layout}>
                <FormItem label='分类'>
                  {getFieldDecorator('categoryId', {
                    rules: [{ required: false, message: '请选择分类' }],
                  })(
                    <Select
                      placeholder='请选择分类'
                      allowClear
                      showSearch
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      <Select.Option key={0} value={0}>
                        {'未分类'}
                      </Select.Option>
                      {categoryList.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.value}
                        </Select.Option>
                      ))}
                    </Select>,
                  )}
                </FormItem>
              </Col>
              <Col {...layout}>
                <FormItem label='关联状态'>
                  {getFieldDecorator('spuFlg', {
                    rules: [{ required: false, message: '请选择关联状态' }],
                  })(
                    <Select
                      placeholder='请选择关联状态'
                      allowClear
                      showSearch
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      <Select.Option key={0} value={null}>
                        全部
                      </Select.Option>
                      <Select.Option key={1} value={true}>
                        已关联
                      </Select.Option>
                      <Select.Option key={2} value={false}>
                        未关联
                      </Select.Option>
                    </Select>,
                  )}
                </FormItem>
              </Col>
              <Col {...layout}>
                <FormItem>
                  <Button type='primary' htmlType='submit'>
                    查询
                  </Button>
                  <Button style={{ marginLeft: '20px' }} onClick={this.handleReset}>
                    重置
                  </Button>
                </FormItem>
              </Col>
            </Row>
          </Form>
        </div>
        <Table
          rowKey={(_, index) => index}
          dataSource={pageList}
          columns={columns}
          loading={loading}
          pagination={pagination}
          onChange={this.pageSwitch}
        />
        <Modal
          title='关联SPU'
          width={950}
          visible={visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
        >
          <div>
            {/* 顶部提示 */}
            <Alert
              message='更换关联的菜小秘货品后，数据将迁移至新选择的基库货品下。'
              type='info'
              showIcon
              style={{ marginBottom: 16 }}
            />
            {/* 查询条件 */}
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
              <span style={{ marginRight: 8 }}>基库货品：</span>
              <Input
                placeholder='请输入基库货品查询'
                value={searchValues.name}
                onChange={(e) =>
                  this.setState({ searchValues: { ...searchValues, name: e.target.value } })
                }
                style={{ width: 220, marginRight: 16 }}
                allowClear
              />
              <span style={{ marginRight: 8 }}>货品分类：</span>
              <TreeSelect
                style={{ width: 200, marginRight: 16 }}
                treeLine
                treeDefaultExpandAll
                placeholder='请选择货品分类'
                allowClear
                showSearch
                treeData={this.convertToTreeData(treeData, false)}
                filterTreeNode={(input, treeNode) => {
                  return treeNode.props.title.indexOf(input) >= 0;
                }}
                value={searchValues.categoryId}
                onChange={(value) =>
                  this.setState({ searchValues: { ...searchValues, categoryId: value } })
                }
              />
              <Button
                type='primary'
                onClick={this.handleSpuSearch}
                style={{ marginRight: 8, marginBottom: 0 }}
              >
                查询
              </Button>
              <Button onClick={this.handleSpuReset} style={{ marginBottom: 0 }}>
                重置
              </Button>
            </div>
            {/* 表格和单选 */}
            <AntTable
              rowKey='id'
              dataSource={dataSource.pageList || []}
              columns={testcolumns}
              rowSelection={{
                type: 'radio',
                hideSelectAll: true,
                selectedRowKeys: selectedRowKeys,
                onChange: this.onSelectChange,
              }}
              pagination={{
                current: defaultCurrent,
                pageSize,
                total: dataSource.totalSize,
                showSizeChanger: false,
              }}
              onChange={this.supPageSwitch}
              size='small'
            />
          </div>
        </Modal>
      </div>
    );
  }
}

export default StallProductList;
